import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export const toLocalCalendarTime = (
  timestamp: Dayjs,
  timeZone: string
): Dayjs => {
  const utcTimestamp = dayjs.utc(timestamp);
  // UTC mode keeps calendar arithmetic independent of browser DST.
  return utcTimestamp.add(utcTimestamp.tz(timeZone).utcOffset(), "minute");
};

export const getCurrentCalendarMonth = (timeZone: string): Dayjs =>
  toLocalCalendarTime(dayjs(), timeZone).startOf("month");
